import React from 'react';
import Assembly from './assembly';
import Subscriptions from './subscriptions';
import './sass/add-ons.scss';

function AddOns({
  selectedOption,
  fulfillmentDetails,
  shippingDetails
}) {
  return (
    <div className="add-ons__wrapper">
  		<Assembly
  			fulfillmentDetails={fulfillmentDetails}
  			selectedOption={selectedOption}
  		/>
      <Subscriptions
        fulfillmentDetails={fulfillmentDetails}
        shippingDetails={shippingDetails}
        selectedOption={selectedOption}
      />
    </div>
  );
}

export default AddOns;
